import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSiteConfig = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 20,
	viewBox: "0 0 16 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 8.7C0.8 8.3 0 7.2 0 5.9C0 4.6 0.8 3.5 2 3.1V1C2 0.4 2.4 0 3 0C3.6 0 4 0.4 4 1V3.2C5.2 3.6 6 4.7 6 6C6 7.3 5.2 8.4 4 8.8V8.9V18.4C4 19 3.6 19.4 3 19.4C2.4 19.4 2 19 2 18.4V8.8V8.7ZM2 5.9C2 6.5 2.4 6.9 3 6.9C3.6 6.9 4 6.5 4 5.9C4 5.3 3.6 4.9 3 4.9C2.4 4.9 2 5.3 2 5.9ZM13.6992 10.7C14.8992 11.1 15.6992 12.2 15.6992 13.5C15.6992 14.8 14.8992 15.9 13.6992 16.3V18.4C13.6992 19 13.2992 19.4 12.6992 19.4C12.0992 19.4 11.6992 19 11.6992 18.4V16.3C10.4992 15.9 9.69922 14.8 9.69922 13.5C9.69922 12.2 10.4992 11.1 11.6992 10.7V10.6V1C11.6992 0.4 12.0992 0 12.6992 0C13.2992 0 13.6992 0.4 13.6992 1V10.6V10.7ZM13.6992 13.5C13.6992 12.9 13.2992 12.5 12.6992 12.5C12.1992 12.5 11.6992 13 11.6992 13.5C11.6992 14.1 12.0992 14.5 12.6992 14.5C13.2992 14.5 13.6992 14.1 13.6992 13.5Z",
		fill: "white"
	})
});
export default SvgSiteConfig;
